import { useLayoutEffect, useState, useRef } from "react";

export function useFixed() {
  const [fixed, setFixed] = useState(false);
  const [style, setStyle] = useState({});

  const headRef = useRef(null);

  useLayoutEffect(() => {
    const sticky = headRef.current.getBoundingClientRect().y;
    const header = document.querySelector(".header");
    const height = header.getBoundingClientRect().height;

    setStyle({ top: height });

    const el = document.querySelector(".modal__content") || window;

    const handleScroll = () => {
      if (headRef.current.getBoundingClientRect().y < height) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    el.addEventListener("scroll", handleScroll);

    return () => {
      el.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return [fixed, setFixed, headRef, style];
}

export function useFixedWidth(loading, ref) {
  useLayoutEffect(() => {
    if (!loading) {
      const th = ref.current.querySelectorAll("th");
      th.forEach(e => {
        e.style.width = Math.round(e.offsetWidth) + "px";
      });

      const td = ref.current.querySelectorAll("td");
      td.forEach(e => {
        e.style.width = Math.round(e.offsetWidth) + "px";
      });
    }
  }, [loading]);
}
